<section class="my_favourites_sec">
  <div class="custom-tabs">
    <mat-tab-group [@.disabled]="true">
      <!--  Catalogues Favourites-TAB -->
      <mat-tab>
        <ng-template mat-tab-label>
          Catalogues
        </ng-template>
        <div class="custom-tab-body catalogues_favourites_body">
          <div class="row-wrap my_fav_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch">
            <ng-container *ngIf="userCats; else loadingTemplate">
              <ng-container *ngIf="userCats.length; else noDataTemplate">
                <div class="column favourite_number my_fav_column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="33"
                  fxFlex.xs="100" fxFlexFill *ngFor="let single of userCats">
                  <div class="catalogues_box">
                    <div class="catalogues_img">
                      <img [src]="single?.catalogue?.thumbnail_image?.url"
                        [routerLink]=" ['/catalogues/details', single.id]">
                    </div>
                    <div class="catalogues_content">
                      <div class="flex_center">
                        <h4 [title]="single?.catalogue?.title">{{single?.catalogue?.title}}</h4>
                      </div>
                    </div>
                    <div class='wish-check'>
                      <button type="button" (click)="deleteCatsFavorites(single)" class="red-heart-btn favorite"
                        mat-icon-button>
                        <i class="material-icons">
                          favorite
                        </i>
                        <div class="effect-group">
                          <span class="effect"></span>
                          <span class="effect"></span>
                          <span class="effect"></span>
                          <span class="effect"></span>
                          <span class="effect"></span>
                        </div>
                      </button>
                    </div>
                    <!-- <div class='wish-check'>
                  <button type="button" (click)="deleteCatsFavorites(single)" class="red-heart-btn" mat-icon-button>
                    <i class="material-icons">
                      favorite
                    </i>
                  </button>
                </div> -->
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #loadingTemplate>
              <div class="custom-loader custom_logo_loader">
                <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
              </div>
            </ng-template>
            <ng-template #noDataTemplate>
              <div class="no-data empty-img">
                <!-- EMPTY-STATE -->
                <img src='../../../../../../../assets/images/empty-imgs/no_favourites.svg' alt="img" loading="lazy" />
                <h4 class="no_state_heading">No Favourites</h4>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-tab>
      <!--  Supplies Favourites-TAB -->
      <mat-tab>
        <ng-template mat-tab-label>
          Supplies
        </ng-template>
        <div class="custom-tab-body supplies_favourites_body">
          <div class="row-wrap my_fav_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch">
            <ng-container *ngIf="supplyFavoritesList; else suppliesLoadingTemplate">
              <ng-container *ngIf="supplyFavoritesList.length; else suppliesNoDataTemplate">
                <div class="my_fav_column" fxLayout="column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="100" fxFlex.xs="100"
                  fxFlexFill *ngFor="let singleFavorite of supplyFavoritesList">
                  <app-single-favorite-product [singleFavorite]="singleFavorite" (deleted)="productRemoved($event)">
                  </app-single-favorite-product>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <!-- TABLE-PAGINATOR -->
          <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
            fxFlexFill fxLayoutGap="8px">
            <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)">
            </mat-paginator>
          </div>
        </div>
        <ng-template #suppliesLoadingTemplate>
          <div class="custom-loader custom_logo_loader">
            <img src='../../../../../assets/loader.webp' alt="img" loading="lazy" />
          </div>
        </ng-template>
        <ng-template #suppliesNoDataTemplate>
          <div class="no-data empty-img">
            <!-- EMPTY-STATE -->
            <img src='../../../../../../../assets/images/empty-imgs/no_favourites.svg' alt="img" loading="lazy" />
            <h4 class="no_state_heading">No Favourites</h4>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
